module.exports = __webpack_public_path__ + "static/fireTV+TV-6133b39f0a5c24d3c210124959455412.png";